export default __webpack_public_path__ + "static/media/app-store.fa603df2.svg";